export function isRAM64Message(msg: any): boolean {
    return msg?.ram64 === true;
}
